import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss']
})
export class ScrollTopComponent implements OnInit {

  toTopButtonVisible = false;
  lastScrollY = 0;

  constructor(
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngOnInit() {
  }

  @HostListener('window:scroll', [ '$event' ])
  onWindowScroll(event: Event) {
    const scrollYKey = 'scrollY';
    if (300 < event.currentTarget[scrollYKey]) {
      this.toTopButtonVisible = true;
    } else {
      this.toTopButtonVisible = false;
    }
  }

  scrollToTop() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    let lastScrollY = document.documentElement.scrollTop || document.body.scrollTop;
    (function smoothScroll() {
        const currentScrollY = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScrollY > 0 && lastScrollY >= currentScrollY) {
            lastScrollY = currentScrollY - (currentScrollY / 8);
            window.requestAnimationFrame(smoothScroll);
            window.scrollTo(0, lastScrollY);
        }
    })();
  }

}
